const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const parseResponse = async (res) => {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const payload = await res.json();
      detail = payload?.detail || detail;
    } catch (_e) {
      // ignore
    }
    throw new Error(detail);
  }
  return res.json();
};

const request = async (path) => {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return parseResponse(response);
};

export const fetchCapacityPlanningSummary = () => request('/api/capacity-planning/summary');

export const fetchExpansionCandidates = () => request('/api/capacity-planning/candidates');

export const fetchTopExpansionCandidates = (limit = 10) =>
  request(`/api/capacity-planning/candidates/top?limit=${encodeURIComponent(limit)}`);
